import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const markLocalTaxiRequestConfirmed = async (scheduledRideId: number) => {
  const response = await mutationExecute({
    variables: {
      scheduledRideId,
    },
    mutation: graphql(`
      mutation markLocalTaxiRequestConfirmed($scheduledRideId: Float!) {
        markLocalTaxiRequestConfirmed(scheduledRideId: $scheduledRideId)
      }
    `),
  });

  return response.data?.markLocalTaxiRequestConfirmed ?? false;
};
